import { CommonResponse } from '../materialList/types'
import { httpRequest } from '../request'
import { PermissionType, Permissions } from './type'

const Apis = {
  USER_PERMISSIONS: 'user_permissions',
  USER_PERMISSION: 'user_permission',
}

// 获取用户所有的功能权限
export const fetchUserPermissions = () => {
  return httpRequest.get<CommonResponse<Permissions>>(Apis.USER_PERMISSIONS)
}

// 获取用户对应功能的权限
export const fetchUserPermission = (params: {
  permission_type: PermissionType
}) => {
  return httpRequest.get<CommonResponse<{ enable: boolean }>>(
    Apis.USER_PERMISSION,
    params
  )
}
